import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { SendChatCommunication } from "src/app/core/model/v2/chat/save-chat";
import { SearchPatientReq } from "src/app/core/model/v2/practice/searchPatientList";
import { Patient } from "src/app/core/models/patient/patient";
import { ChatService } from "src/app/core/services/v2/chat.service";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { PhysicianOptionService } from "../../shared/physician-option/physician-option.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material"
@Component({
  selector: "app-send-multiple-messages",
  templateUrl: "./send-multiple-messages.component.html",
  styleUrls: ["./send-multiple-messages.component.scss"],
})
export class SendMultipleMessagesComponent implements OnInit {
  @ViewChild('chatmsg', { static: false }) chatinput;
  @Input() sectionName: string;
  @Output() cancelEvent = new EventEmitter();
  @Output() toggleEvent = new EventEmitter();
  @Input() data: any;
  @Input() employerId: any;
  @Input() isMember: boolean=false;
  @Input() title: string="Patient";
  searchData: Patient[];
  filteredData: Patient[];
  selectedPatients: number[] = [];
  chatCommunication: SendChatCommunication = new SendChatCommunication();
  stepNo: number = 1;

  constructor(
    private practiceService: PracticeService,
    private chatService: ChatService,
    private physicianOptionService: PhysicianOptionService,
    private loaderService: WindowLoaderService,
    @Inject(MAT_DIALOG_DATA) public dialogdata: any,
  ) { }

  ngOnInit() {
    
    if (this.employerId !=undefined) {
      console.log("EMPID: " + this.employerId); 
    }
    this.searchPatient();
  }

  searchPatient() {
    
    const searchReq: SearchPatientReq = new SearchPatientReq();
    searchReq.userId = this.physicianOptionService.getPhysician().userId == undefined ? 0 : this.physicianOptionService.getPhysician().userId;
    searchReq.pageIndex = 1;
    searchReq.itemsCount = 9999;
    searchReq.criteria = "";

    if (this.employerId >0 || searchReq.userId || this.isMember) {
      //   this.loaderService.show();
      //   this.practiceService.getPractitionerPatientsList(searchReq).subscribe(
      //     res => {
      //       this.searchData = res.patients;
      //       this.searchData.forEach(x => x['selected'] = true);
      //       this.filteredData = this.searchData;
      //       this.selectedPatients = [];
      //       this.filteredData.forEach(x => this.selectedPatients.push(x.id));
      //       this.loaderService.hide();
      //     },
      //     (error) => { console.error(error); this.loaderService.hide(); },
      //     () => { this.loaderService.hide(); }
      //   );
      
      this.searchData = this.data;
      if (this.employerId == undefined) {
        this.searchData.forEach((x) => (x["selected"] = true));
      }
      this.filteredData = this.searchData;
      this.selectedPatients = [];
      this.filteredData.forEach((x) => this.selectedPatients.push(x.id));
    }
  }

  showAllPatients() {
    this.filteredData = this.searchData;
    this.selectedPatients = [];
    this.filteredData.forEach((x) => this.selectedPatients.push(x.id));
  }

  showNewPatients() {
    this.filteredData = this.searchData.filter((x) => !x.userId);
    this.selectedPatients = [];
    this.filteredData.forEach((x) => this.selectedPatients.push(x.id));
  }

  onChange(patient: Patient, isChecked: boolean,data:any) {
    patient["selected"] = isChecked;
    if (isChecked) {
      this.selectedPatients.push(patient.id);
    } else {
      this.selectedPatients = this.selectedPatients.filter(
        (x) => x != patient.id
      );
    }
    if(data)
    {this.searchPatient();}
  }

  nextStep() {
    this.stepNo++;
  }

  backStep() {
    this.stepNo--;
  }

  getNavCode(step: number): string {
    var navCode: string = "nav-status";

    if (step == 1) {
      if (this.stepNo == 1) navCode += " progress";
      else navCode += " completed";
    } else if (step == 2) {
      if (this.stepNo == 2) navCode += " progress";
      else if (this.stepNo < 2) navCode += " pending";
      else if (this.stepNo > 2) navCode += " completed";
    }
    return navCode;
  }

  sendMessage() {
    
    if (this.dialogdata.isFromAdmin) {
      
      this.sendCommunicationGlobal();
    }
    else {
      
      this.sendCommunication();
    }
  }
  sendCommunication() {
    
    this.chatCommunication.content = this.chatinput.nativeElement.innerHTML == "" ? this.chatinput.nativeElement.value : this.chatinput.nativeElement.innerHTML;
    this.chatCommunication.toPatientIds = this.selectedPatients;
    this.chatCommunication.practitionerId =
      this.physicianOptionService.getPhysician().id == undefined ? 0 : this.physicianOptionService.getPhysician().id;
    this.chatCommunication.employerId = this.employerId == null ? 0 : this.employerId;
    this.loaderService.show();
    this.chatService.sendCommunication(this.chatCommunication).subscribe(
      (_) => {
        this.loaderService.hide();
        this.toggleEvent.emit();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  sendCommunicationGlobal() {
    this.chatCommunication.content = this.chatinput.nativeElement.innerHTML;
    this.chatCommunication.toPatientIds = this.selectedPatients;
    this.chatCommunication.practitionerId = 0;     
    this.loaderService.show();
    this.chatService.sendCommunicationGlobal(this.chatCommunication).subscribe(
      (_) => {
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );

  }
}
